





































































import _ from 'lodash';
import {
  ModalMixin,
  Modal,
  ResourceLoader,
  notify,
  AsyncBtn,
} from 'mycorems-app-shared';
import { AccountType } from 'mycorems-app-accounts';
import { AddOrSelectPaymentMethod, CalculatedPrice } from 'mycorems-app-billing';
import isGranted from '@/auth/isGranted';
import { HasTaskMixin } from '@/mixins';
import accountRepository from '@/account/account-repository';
import {
  Account,
  AccountPricePlan,
  ModalElement,
  PricePlan,
} from '@/types';
import accountPricePlanService from './account-price-plan';
import PricePlansTable from '../price-plan/PricePlansTable.vue';

interface Data {
  findAccountTask: Promise<Account>|null,
  account: Account|null,
  AccountType,
  pricePlan: PricePlan|null,
  payerAccountType: number|null
  paymentMethodId: string|null,
}

export default HasTaskMixin.extend({
  mixins: [ModalMixin],
  props: {
    accountId: String,
  },
  data(): Data {
    return {
      findAccountTask: null,
      account: null,
      AccountType,
      pricePlan: null,
      payerAccountType: AccountType.AGENCY,
      paymentMethodId: null,
    };
  },
  watch: {
    accountId: {
      handler() {
        this.loadAccount();
      },
      immediate: true,
    },
    payerAccountType(): void {
      this.clearPaymentMethod();
    },
  },
  computed: {
    title(): string {
      let title = 'Purchase CM Reports Credits';
      if (this.account) {
        title += ` - ${this.account.name}`;
      }
      return title;
    },
    isClient(): boolean {
      return (this.account !== null && this.account.type === AccountType.CLIENT);
    },
    isAgencyPaying(): boolean {
      return (this.isClient && this.payerAccountType === AccountType.AGENCY);
    },
    currency(): string {
      return 'USD';
    },
    customerId(): string|null {
      if (!this.account) return null;
      return this.isAgencyPaying ? this.account.parentId : this.accountId;
    },
    canPurchase(): boolean {
      return (!_.isNil(this.pricePlan) && this.paymentMethodId !== null);
    },
    payerText(): string {
      if (this.isClient) {
        return this.isAgencyPaying ? 'Agency' : 'Client';
      }
      return '';
    },
  },
  methods: {
    loadAccount() {
      this.findAccountTask = accountRepository.find(this.accountId);
      this.findAccountTask.then((account) => {
        this.account = account;
      });
    },
    selectPricePlan(pricePlan: PricePlan) {
      this.pricePlan = pricePlan;
    },
    purchase(): void {
      if (!this.pricePlan || !this.paymentMethodId) return;
      this.task = accountPricePlanService.start(
        this.accountId, this.pricePlan.id, this.paymentMethodId,
      );
      this.task.then((accountPricePlan: AccountPricePlan) => {
        this.$emit('ok', accountPricePlan);
        (this.$refs.modal as ModalElement).hide();
        notify.success('Thank you for your purchase!');
      });
    },
    clearPaymentMethod(): void {
      this.paymentMethodId = null;
    },
    isGranted,
  },
  components: {
    modal: Modal,
    ResourceLoader,
    'price-plans-table': PricePlansTable,
    'add-or-select-payment-method': AddOrSelectPaymentMethod,
    'calculated-price': CalculatedPrice,
    'async-btn': AsyncBtn,
  },
});
